import React from 'react';
import ReactGA from 'react-ga';

import { GetPrivacyModes, SetGlobalPrivacyMode } from 'api/privacyAPICall';
import { spawnDialogWindow } from 'components/dialogHolder';
import { _I_ } from 'components/translate';
import { BootButton, CloseButton } from 'generics/buttons';
import { utils_api } from 'generics/common';
import { IconFontAwesome, IconLanguage } from 'generics/icons';
import { getEnabledLocales } from 'generics/localeUtils';
import { SettingsInjections } from 'generics/settingsInjections';
import { classMixer } from 'generics/utils';

export function spawnUserSettingsModal() {
  Promise.all([
    GetPrivacyModes()
  ])
    .then(
      ([privacyModes]) => {
        spawnDialogWindow(ViewUserSettingsDialog, { privacyMode: privacyModes[0] });
      }
    );
}

function setUsedLocale(code) {
  utils_api.setStored(["AchievementApp", "LRU", "locale"], code);
  utils_api.sheduleReload();
}


export default class ViewUserSettingsDialog extends React.Component {
  constructor(props) {
    super(props);

    const currentLocale = SettingsInjections.getUsedLocale();

    this.state = {
      localeCode: currentLocale.code,
      privacyMode: this.props.privacyMode
    }
  }

  componentDidMount() {
    ReactGA.modalview('usersettings');
  }

  onBackdropTouch() {
    this.props.removeModal();
  }


  onSaveButton() {
    const currentLocale = SettingsInjections.getUsedLocale();
    if (currentLocale.code != this.state.localeCode) {
      setUsedLocale(this.state.localeCode);
    }

    SetGlobalPrivacyMode(this.state.privacyMode);

    this.props.removeModal();
  }


  renderLocales() {
    const items = getEnabledLocales().map(({ name, code, icon, enabled }, key) => {
      const isCurrent = (this.state.localeCode == code);
      return (<BootButton key={code}
        variant={isCurrent ? "success" : "default"}
        disabled={!enabled}
        onClick={() => this.setState({ localeCode: code })}
      >
        <IconLanguage code={icon} small labelNative labelEnglish />
      </BootButton>);
    });


    return (<div>
      <div className="label label-default text-center">{_I_("UserSettingDialog.language")}</div>
      <div className="well well-sm view-user-settings-localeset">{items}</div>
    </div>);

  }

  renderPrivacyValue(itemValue) {
    const checkedClassName = classMixer("fa", itemValue.active ? "fa-check-circle-o" : "fa-circle-o");

    return (
      <div className="privacy-entry"
        key={itemValue.internal_name}
        onClick={() => this.setState({ privacyMode: itemValue.internal_name })}
      >
        <i className={checkedClassName} />&nbsp;
        <span>{itemValue.name}</span>
      </div>);
  }

  renderPrivacy() {
    const { privacyMode } = this.state;
    const privacyItems = [
      {
        'name': _I_("UserSettingDialog.allUsers"),
        'internal_name': 'PUBLIC',
        'active': (privacyMode == 'PUBLIC')
      },
      {
        'name': _I_("UserSettingDialog.friendsOnly"),
        'internal_name': 'FRIENDS_ONLY',
        'active': (privacyMode == 'FRIENDS_ONLY')
      },
      {
        'name': _I_("UserSettingDialog.onlyMe"),
        'internal_name': 'PRIVATE',
        'active': (privacyMode == 'PRIVATE')
      }
    ];


    return (
      <div>
        <div className="label label-default text-center">{_I_("UserSettingDialog.privacy")}</div>
        <div className="well well-sm">
          <div className="view-user-settings-title">{_I_("UserSettingDialog.whoCanView")}</div>
          {privacyItems.map((itemValue) => this.renderPrivacyValue(itemValue))}
        </div>
      </div>
    );
  }

  render() {
    const appMode = SettingsInjections.getMode();

    return (
      <div className="panel panel-primary panel-sm view-user-settings-dialog">
        <div className="panel-heading">
          <IconFontAwesome type="gear" fixedWidth />
          &nbsp;{_I_("UserSettingDialog.userSettings")}
          <CloseButton onClick={this.props.removeModal} />
        </div>

        <div className="panel-body">
          <div className="text-center">
            <IconFontAwesome type="gear" size="3x" fixedWidth />
            &nbsp;<b>{_I_("UserSettingDialog.settings")} </b>
          </div>
          {appMode !== 'pixstorm' && this.renderLocales()}
          {this.renderPrivacy()}
          <div className="text-center">
            <hr />
            <BootButton variant="success" onClick={() => this.onSaveButton()} >
              <IconFontAwesome type="floppy-o" />&nbsp;{_I_("UserSettingDialog.saveSettings")}
            </BootButton>
          </div>
        </div>
      </div>
    );
  }
}